<template>
    <div>
        <div class="container-fluid p-0">
            <card>
                <template slot="header">
                    <h4>وضعیت فروش</h4>
                    <hr />
                </template>
                <template slot="content">
                    <div class="row">
                    <div class="col-lg-4 col-6">
                        <div class="row">
                        <div class="col-12">
                            <b-form-group v-slot="{ ariaDescribedby }">
                            <b-form-radio-group id="btn-radios-3" @change="SelectDate" v-model="selected" :options="['امسال','همه']" :aria-describedby="ariaDescribedby" name="radio-btn-stacked" buttons stacked></b-form-radio-group>
                            </b-form-group>
                        </div>
                        </div>
                    </div>
                    <div class="col-lg-8 text-center">
                        <div v-if="ChartDataMonth==null" class="w-100">
                            <h5>در این بازه فروشی ثبت نشده است</h5>
                            </div>
                            <apexchart v-if="selector==1"  height="450"  :options="chartOptions" :series="series"></apexchart>
                            <apexchart v-if="selector==2"  height="450"  :options="chartOptions2" :series="series2"></apexchart>

                    </div>
                    <div class="col-12 pt-6">
                        
                    </div>
                    </div>
                </template>
            </card>
        </div>
    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
export default {
  components: { Card },
    data (){
        return {
          series: [{data: [],name:'تعداد فروش',type: 'column'},{data:[],name:'مجموع فروش',type: 'line'}],
          series2: [{data: [],name:'تعداد فروش',type: 'column'},{data:[],name:'مجموع فروش',type: 'line'}],

            render:false,
            ChartDataMonth: null,
            chartOptions: {
            chart: {
              height: 450,
              type: 'line',
              events: {
                click: function(chart, w, e) {
                  // console.log(chart, w, e)
                }
              }
            },
            stroke: {
              width: [0, 4]
            },
           
            dataLabels: {
              enabled: true,
              enabledOnSeries: [1]
            },
            colors: ['#FDA700', '#fd397a', '#1dc9b7', '#5CB0FF', '#5578eb'],
            plotOptions: {
              bar: {
                columnWidth: '45%',
                distributed: true,
              }
            },
            yaxis: [{
              title: {
                text: '',
              },
            
            }, {
              opposite: true,
              title: {
                text: ''
              }
            }],

              labels:['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسنفد'],

          }
          ,
          chartOptions2: {
            chart: {
              height: 450,
              type: 'line',
              events: {
                click: function(chart, w, e) {
                  // console.log(chart, w, e)
                }
              }
            },
            stroke: {
              width: [0, 4]
            },
           
            dataLabels: {
              enabled: true,
              enabledOnSeries: [1]
            },
            colors: ['#FDA700', '#fd397a', '#1dc9b7', '#5CB0FF', '#5578eb'],
            plotOptions: {
              bar: {
                columnWidth: '45%',
                distributed: true,
              }
            },
            yaxis: [{
              title: {
                text: '',
              },
            
            }, {
              opposite: true,
              title: {
                text: ''
              }
            }],

              labels:['1390','1391','1392','1393','1394','1395','1396','1397','1398','1399','1400','1401','1402'],

          }
        }
    },
    methods:{

        SelectDate() {
             if (this.selected == 'امسال') this.selector = 1
             else if (this.selected == 'همه') this.selector = 2
             this.series[0].data=[]
          this.series[1].data=[]
          this.series2[0].data=[]
          this.series2[1].data=[]
            this.getData(this.selector)
        },
        getData(selector){
            this.ChartDataMonth=null
    var DataAxiosMonth = { Action: 'DashboardSales/ChartContracts', Method: 'POST', ArryfildValue: {typeChart:selector} }
      this.$PostData(DataAxiosMonth).then((result) => {
        // console.log(result);
        var ExistingMonths = []
        
      //   result.data.forEach((element) => {
      //     ExistingMonths.push(element.yearsORmonths)
      //   })
      //   var AllMonths = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
      //   AllMonths.forEach((month) => {
      //     if (ExistingMonths.indexOf(month) == -1) {
      //       result.data.push({ yearsORmonths: month, ContractCount: 0 })
      //     }
      //   })
      //   result.data.sort((a, b) => {
      //     if (a.yearsORmonths < b.yearsORmonths) {
      //       return -1
      //     }
      //     if (a.yearsORmonths > b.yearsORmonths) {
      //       return 1
      //     }
      //     return 0
      //   })
      //   if(selector==1){
      //   result.data.forEach((element) => {
      //     // console.log('element',element);
      //     switch (element.yearsORmonths) {
      //       case '01':
      //         element.yearsORmonths = 'فروردین'
      //         break
      //       case '02':
      //         element.yearsORmonths = 'اردیبهشت'
      //         break
      //       case '03':
      //         element.yearsORmonths = 'خرداد'
      //         break
      //       case '04':
      //         element.yearsORmonths = 'تیر'
      //         break
      //       case '05':
      //         element.yearsORmonths = 'مرداد'
      //         break
      //       case '06':
      //         element.yearsORmonths = 'شهریور'
      //         break
      //       case '07':
      //         element.yearsORmonths = 'مهر'
      //         break
      //       case '08':
      //         element.yearsORmonths = 'آبان'
      //         break
      //       case '09':
      //         element.yearsORmonths = 'آذر'
      //         break
      //       case '10':
      //         element.yearsORmonths = 'دی '
      //         break
      //       case '11':
      //         element.yearsORmonths = 'بهمن'
      //         break
      //       case '12':
      //         element.yearsORmonths = 'اسفند'
      //         break
      //     }
          
      //      element.name=[]
      //   })
      // }
      //   else{
      //     for (let index = 0; index < result.data.length; index++) {
      //        result.data[index].yearsORmonths=result.data[index].yearsORmonths;   
      //     }

      //   }

        this.ChartDataMonth=result.data
        // console.log(this.ChartDataMonth);
        this.getChart(this.ChartDataMonth)

      })
        },
        getChart(data){
         
          this.render=true
            data.forEach((element) => {
              if(this.selector==1){
                this.series[0].data.push(element.ContractCount)
                 this.series[1].data.push(element.SumMablagh)  
              }else if(this.selector==2){
                this.series2[0].data.push(element.ContractCount)
                 this.series2[1].data.push(element.SumMablagh)  
              }
                 
          })
          
        }
    },

}
</script>
<style scoped>

</style>
<style>
div.apexcharts-tooltip-title {
  font-family: 'IRANSansWeb' !important;
  color: var(--sidebar-color-item) !important;
  fill: var(--sidebar-color-item) !important;
  background: var(--sidebar-action-bg) !important;
}
div.apexcharts-tooltip-series-group {
  font-family: 'IRANSansWeb' !important;
  color: var(--sidebar-color-item) !important;
  fill: var(--sidebar-color-item) !important;
  background: var(--sidebar-action-bg) !important;
}
span.apexcharts-tooltip-text-y-label {
  font-family: 'IRANSansWeb' !important;
  color: var(--sidebar-color-item) !important;
  fill: var(--sidebar-color-item) !important;
  background: var(--sidebar-action-bg) !important;
}
</style>